const { updateAnswer } = require("../features/admin/quiz/Slice");

exports.APIS = {
  Auth: {
    CreateCustomerSignup: "/customer-signup",
    SEND_OTP: "/sendOtp",
    VERIFY_OTP: "/otp-verification",
    CreateVendor1Signup: "/vendor-signup",
    CreateVendor2Signup: "/vendor-shop",
    CreateVendor3Signup: "/vendor-receive-docs",
    CreateExpert1Signup: "/expert-signup",
    CreateExpert2Signup: "/expert-details",
    // login: "/login",
    sendLoginOtp: "/sendOtp",
    LoginverifyOtp: "/otp-verification",
    GETCustomer: "/get-customer",
    GETVendor: "/get-vendor",
    GETExpert: "/get-expert",
    Update_Customer: "/update-customer-profile",
    Update_Vendor: "/update-vendor-profile",
    Update_Expert: "/update-expert-profile",
    Update_Vendor_Shop: "/update-vendor-shop",
  }, // mine
  UserGet: "/common/auth/user-info",
  ChangePassword: "/common/auth/change-password",

  Masters: {
    Country: "/admin/masters/country",
  },

  ContactUs: {
    Contact_Us: "/contactus",
    call_contact_us: "/callcontactus",
  },

  Comment: {
    comments: "/comments",
  },

  Quiz: {
    startQuiz: "/quiz/start",
    updateAnswer: "/quiz/update-answer",
    submitQuiz: "/quiz/submit",
    getQuizResult: "/quiz/result",
  },

  QuizContactUs: {
    quiz_contact_us: "/quiz_contact_us",
  },

  Commons: {
    AllState: "/state",
    AllDistrict: "/district",
    AllCartegory: "/servicecategory",
    AllProfession: "/get-profession",
    AllPrivacyPolicy: "/privacy-policy",
    AllTermcondition: "/terms-condition",
    AllAppSetup: "/appsetup",
    AllCategories: "/servicecategory",
    AllProfessions: "/get-profession",
    AllPurchaseDate: "/get-purchase-date",
    AllTaluka: "/taluqa",
    AllHomeText: "/homestriptext",
    AllBannerText: "/homebannertxt",
    AllHiringPartners: "/hiringpartner",
    AllSuccessStory: "/successStory",
    AllSpotLights: "/spotlight",
    AllLearnVideos: "/learnvideos",
    AllPlacementTeam: "/placementTeam",
    AllAlumniPlace: "/alumniplace",
    AllBuildCareer: "/buildcareer",
    AllBlogs: "/blogs",
    BlogDetail: "/blogsdetail",
    AllInterviewGuide: "/interviewguide",
    AllBranches: "/branches",
    AllQualification: "/qualification",
    AllSocialLinks: "/socialLinks",
    AllMentors: "/mentors",
    AllProgramList: "/programlist",
    ProgramDetail: "/programs",
    AllHomeImage: "/homeimage",
    AllProgramCategory: "/programcategory",
    ProgramByID: "/programCategoryId",
    AllComments: "/getcomments",
    AllQuiz: "/quiz",
    AllIndustryExperts: "/industry_expert",
  },

  UserManagement: {
    Roles: "/admin/employee-management/role",
    Builder: "/admin/employee-management/builder",
    Users: "/admin/employee-management/user",
    Sales: "/admin/employee-management/sales",
  },
  Subscription: {
    Subscription_Plan: "/subscription-plan",
    Buy_Subscription: "/subscription",
    UserWalletHistory: "/get-subscriptionHistory",
  },
  Vendor_Expert: {
    Vendors_Experts: "/web-get-vendors-experts",
    VendorEnquiry: "/vendor-enquiry",
    ExpertEnquiry: "/expert-enquiry",
    getVendorExpertList: "/vendor-expert-history",
    RateUs: "/rate-us",
    getVendorCustomerList: "/vendor-customer-lead",
    getExpertCustomerList: "/expert-customer-lead",
    Vendor_Call: "/vendor-enquiry-call",
    getVendorCustomerHistory: "/vendor-purchase-lead",
    Expert_Call: "/expert-enquiry-call",
    getExpertCustomerHistory: "/expert-purchase-lead",
  },
};
